<div class="custom-snackbar-install">
    <img src="icons/icon-72x72.png" alt="Ringo" class="app-icon" />
    <span class="message">Vuoi installare Ringo?</span>
    <button mat-button color="primary" (click)="install()">INSTALLA</button>
</div>
